import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyAQ4usvLkp3qdnyvsIJ1V-31EM4UkBeI04',
  authDomain: 'the-fullhouse.firebaseapp.com',
  projectId: 'the-fullhouse',
  storageBucket: 'the-fullhouse.appspot.com',
  messagingSenderId: '540933860702',
  appId: '1:540933860702:web:9e9e0f69b76a7b271ef3cf',
};

firebase.initializeApp(firebaseConfig);

const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();
const googleProvider = new firebase.auth.GoogleAuthProvider();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export {projectAuth, projectFirestore, googleProvider, timestamp};
